<div *ngIf="dataChart && dataChartColumns">
  <!-- misurazione fatturato costi -->
  <div class="card card-chart">
    <div class="row justify-content-end mx-1 mb-1">
      <label for="year" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
        <select [(ngModel)]="filterYear" (ngModelChange)="loadEconomic()" id="year" class="form-control pr-3 text-capitalize">
          <option *ngFor="let year of availableYears" [value]="year" [label]="year">{{ year }}</option>
        </select>
      </label>
    </div>
    <div class="row mx-0">
      <div class="col-md-12 col-12 revenue-report-wrapper">
        <div id="revenue-report-chart">
          <apx-chart
            [series]="dataChart?.series"
            [chart]="chartOptions?.chart"
            [xaxis]="dataChart?.xaxis"
            [stroke]="chartOptions?.stroke"
            [yaxis]="chartOptions?.yaxis"
            [tooltip]="chartOptions?.tooltip"
            [legend]="chartOptions?.legend"
            [dataLabels]="chartOptions?.dataLabels"
          ></apx-chart>
        </div>
        <ng-container *ngFor="let serie of (dataChart?.series || [])">
          <div><strong>{{'TOTAL_SINGULAR' | translate}} {{ serie.name | lowercase }}</strong>: {{ getSum(serie.data) | currency: 'EUR' }}</div>
        </ng-container>
      </div>
    </div>
  </div>
</div>